import {
  DASHBOARD2_WELCOME_MESSAGE_KEYS,
  type Dashboard2WelcomePoolKind,
  welcomePoolKindForStatus
} from "../constants/dashboard2-welcome-messages.constants";
import type { DayWorkStatusKind } from "../types/dashboard2-work-status.types";

const hashSeed = (input: string): number => {
  let hash = 0;

  for (let index = 0; index < input.length; index += 1) {
    hash = (hash * 31 + input.charCodeAt(index)) | 0;
  }

  return Math.abs(hash);
};

export const pickDashboard2WelcomeMessageKey = (
  kind: DayWorkStatusKind,
  dateKey: string,
  messageKeysByKind: Record<
    Dashboard2WelcomePoolKind,
    readonly string[]
  > = DASHBOARD2_WELCOME_MESSAGE_KEYS
): string => {
  const poolKind = welcomePoolKindForStatus(kind);
  const keys = messageKeysByKind[poolKind];

  if (keys.length === 0) {
    return "";
  }

  const index = hashSeed(`${dateKey}:${poolKind}`) % keys.length;
  return keys[index] ?? keys[0] ?? "";
};
